<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    공모전 상세정보
                </div>
                <div class="write_tab">
                    <div class="write_tab_content tab_contents "
                         @click="movePage(`/competition/list/${competitionKey}`)">
                        기본정보
                    </div>
                    <div class="write_tab_content tab_contents active"
                         >
                        응모작
                    </div>
                    <div class="write_tab_content tab_contents"
                         @click="movePage(`/competition/list/${competitionKey}/award`)">
                        수상작
                    </div>
                </div>
                <div class="member_write_wrap">
                    <div class="write_content">
                        <div class="write_box" >
                        <competition-list-component :competitionType="`entry`"
                                                    :competitionKey="competitionKey"
                                                    ></competition-list-component>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <judge-info-modal></judge-info-modal>
        <judge-result-modal></judge-result-modal>
        <option-modal></option-modal>
    </div>
</template>

<script>
import CompetitionWriteComponent from "@/components/competition/CompetitionWriteComponent";
import CompetitionListComponent from "@/components/competition/CompetitionListComponent";
import JudgeInfoModal from "@/components/modal/JudgeInfoModal";
import JudgeResultModal from "@/components/modal/JudgeResultModal";
import OptionModal from "@/components/modal/OptionModal";
import EventBus from "@/utils/event-bus";
export default {
    name: "CompetitionDetailEntry",
    mixins: [],
    components: {
        CompetitionWriteComponent,
        CompetitionListComponent,
        JudgeInfoModal,
        JudgeResultModal,
        OptionModal
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            tab: 'detail',
            competitionKey: this.$route.params.idx
        }
    },
    beforeRouteEnter(from,to,next) {
        next()
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        changeTab(tab) {
            this.$router.replace(this.$route.path);
            this.tab = '';
            this.$nextTick(() => {
                this.tab = tab
            })
        },
        deleteCompetition() {
            EventBus.$emit('deleteCompetition')
        },
        movePage(url){
            this.$router.push(url)
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
